module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-project-website"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        DESIGNED WITH YOUR\n                        DONORS IN MIND\n                    ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/open-example-project-website",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("EXAMPLE PROJECT WEBSITE")])])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    directives: [{
      name: "gallery",
      rawName: "v-gallery"
    }],
    staticClass: "img-responsive",
    attrs: {
      "width": "700",
      "height": "608",
      "src": "images/Project-Website/projectwebsite02.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(6)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper project-website"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("PROJECT WEBSITE")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    FREE PROJECT WEBSITE\n                    "), _c('br'), _vm._v("\n                    FOR ALL CLIENTS\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("We make managing your project a breeze.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row project-website-icons"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Project-Website/customizedicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("CUSTOMIZED FOR YOUR PROJECT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Project-Website/paymentsicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("IMMEDIATE & SECURE PAYMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Project-Website/shareyourstoryicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("“SHARE YOUR STORY” FEATURE")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/Project-Website/manageordersicon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("MANAGE ORDERS ANYTIME, ANY DEVICE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "320",
      "src": "images/Project-Website/projectwebsite01.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Step-By-Step Navigation")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Easily Viewed on Any Device")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("High-Quality Product Images")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Custom Inscription Fields with Character Limits")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Immediate Payment & Email Order Confirmation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        EVERY BRICK HAS A STORY\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Behind each custom brick, there is a\n                        personal story. Utilize our “Share Your\n                        Story” feature on your Project Website\n                        and allow donors to share these personal\n                        stories with you and your organization.\n                        Collect and use these stories as you see\n                        fit. They are great for marketing and\n                        creating shared experiences between all\n                        of your donors.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "367",
      "src": "images/Project-Website/projectwebsite03.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        ORDERS ARE AUTOMATICALLY\n                        ADDED TO A GOOGLE SHEET\n                        FOR EASY MANAGEMENT\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Color-Coded Order Status")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Orders Appear Instantly")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Receipt URL for Payments Using Stripe")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Administrative Notes Section")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Automatically Collects Donor Logo Files")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        MULTIPLE PAYMENT\n                        PROCESSING OPTIONS\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Select the payment processing option that\n                        works best for your organization. Choose\n                        from Stripe, Square, PayPal, or Braintree\n                        and take payments automatically.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "frl-recommended"
  }, [_c('img', {
    attrs: {
      "width": "55",
      "height": "58",
      "src": "images/recommendedicon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Stripe is recommended for its full integration with our Project Website and ease of use.")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "189",
      "src": "images/Project-Website/projectwebsite04.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frl-recommended-sm"
  }, [_c('img', {
    attrs: {
      "width": "55",
      "height": "58",
      "src": "images/recommendedicon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Stripe is recommended for its full integration with our Project Website and ease of use.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f61c134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/ProjectWebsite.vue
// module id = MLAZ
// module chunks = 1